import React from 'react';
import './Loading.scss';
import { getDeviceInfo, teslaCacheX } from '../../Upshow';
import ReactPlayer from 'react-player';
import Logger from '../../Logger';
import { getMakeConfig } from '../../utils/models';
import SettingsService from '../../services/SettingsService';

// REBRAND-BETA: remove gate at release
const staticLoadingImage = () => SettingsService.hasFeature('beta') ? 'DAZN_Loading_Static.png' : 'Internal_Loading_Screen.png';

const PlayerWithLoadingScreen = ({url}) => (
    getMakeConfig().loadingState.image
        ? <img
            src={`https://cdn.upshow.tv/ui-assets/${staticLoadingImage()}`}
            alt="Loading"
            style={{width:' 100%', height: 'auto'}}
        />
        : <ReactPlayer
            width="100%" height="100%" volume={0} playing
            url={url}
            onError={(error) => Logger.warn('Loading state could not play loading media', error)}
            config={{
                file: {
                    attributes: {
                        crossOrigin: 'anonymous',
                        poster: 'https://cdn.upshow.tv/1x1.png'
                    }
                }
            }}
        />
);

class Loading extends React.Component {
    constructor (props) {
        super(props);
        // REBRAND-BETA: remove gate at release
        const animation = SettingsService.hasFeature('beta') ? 'DAZN_Power_Up_Screen.mp4' : 'Everpass_Logo_Animation.mp4';
        this.url = teslaCacheX(`https://cdn.upshow.tv/ui-assets/${animation}`);
    }
    render () {
        return <div className="Loading">
            {['AndroidSkykit', 'Skykit'].includes(getDeviceInfo().model)
                ? <></>
                :  <PlayerWithLoadingScreen url={this.url} />
            }
        </div>;
    }
}

export default Loading;